export default function Loading() {
  return <div className="tw-cds-container tw-py-3.2">Loading...</div>;
}
